import 'core-js/stable';
import 'regenerator-runtime/runtime';

import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { loadClientTranslations } from '~l10n/client/translate';
/* ---------------------------------------------------------------------------- */
/*    These statments ensure that webpack bundles the generic code we have    */
/*    written that is common between login.js, student.js, and teacher.js.    */
import { enableES5 } from 'immer';

import { AppView } from '../AppView';
// TODO: Some of these imports are probably not needed - RLP
// Although some of them have side effects. :(
import { setupSocrativeInterceptors } from '../src/api/localAxios';
import { dynamicImport } from '../src/util/dynamicImport';

enableES5(); // This is to enable IE11 support for immerjs https://immerjs.github.io/immer/installation/#immer-on-older-javascript-environments

require('../../shared/less/student.less');
require('extensions');

let user = require('user');
let room = require('room'); // eslint-disable-line
let popup = require('../../shared/components/popup/PopupController'); // eslint-disable-line
let Select = require('Select'); // eslint-disable-line
let DownChevronSmall = require('DownChevronSmall'); // eslint-disable-line
let InfoIcon = require('InfoIcon'); // eslint-disable-line

/* ---------------------------------------------------------------------------- */
let Backbone = require('backbone');

const StudentRouter = dynamicImport({
  moduleImport: () =>
    import(/* webpackChunkName: 'student-router' */ 'student-router'),
});

user.setModeSilent('student');
user.getCookieData();
setupSocrativeInterceptors();
loadClientTranslations(user.getLanguage()).then(() => {
  StudentRouter().then(() => {
    ReactDOM.render(
      React.createElement(AppView, { user: user }),
      document.getElementById('content-container')
    );
    SOCRATIVE.checkTime.reset();
    SOCRATIVE.initTemplateLoader.stop(); // Hide the loading message (if it's visible)
    Backbone.history.start();
  });
});
